import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import * as _ from "lodash";

import * as styles from './style.css';
import Icon from "../../../../icons/Icon";
import { currentUserInfoSelector } from 'src/app/modules/auth/store/auth-user/selectors';
import { setSidebarVisibility } from '../../../../layout/store/actions';
import { getTranslationLang } from '../../../../../i18n';

const themes = { light: '#fff', dark: '#7B6CE6', darkBlue: '#252D76' };
class LayoutComponentsHeader extends PureComponent {

  static propTypes = {
    onBack: PropTypes.func,
    showGreeting: PropTypes.bool,
    showBackBtn: PropTypes.bool,
    showLogo: PropTypes.bool,
    theme: PropTypes.string
  };

  static defaultProps = {
    onBack: () => {},
    showLogo: false,
    showBackBtn: false,
    showGreeting: false,
    onShowSidebar: () => {},
    theme: 'dark'
  };

  onBackPressed = () => {
    this.props.onBack();
  };

  onHamburgerPressed = () => {
    this.props.setSidebarVisibility(true);
  }

  renderGreetingText() {
    let greetingText = '';
    if (!_.isEmpty(this.props.currentUserInfo)) {
      const { display_name } = this.props.currentUserInfo;
      if (display_name) {
        greetingText = `${this.props.t('withName')} ${display_name}!`;
      } else {
        greetingText = this.props.t('withoutName');
      }
    } else {
      greetingText = this.props.t('anonymous');
    }
    return (<div className={`${styles.headerText} font-title`}>{greetingText}</div>);
  }

  render() {
    const { theme, showGreeting, showLogo } = this.props;
    const humburger = theme === 'dark' || 'darkBlue' ? 'HamburgerLight' : 'HamburgerDark';
    const humburgerStyle = getTranslationLang() === 'en' ? {position: 'absolute', right: '14px'} : {position: 'absolute', left: '14px'}
    return (
      <div className={styles.header} 
           style={{ backgroundColor: themes[theme], justifyContent: showLogo ? 'center' : 'space-between'}}>
        { this.props.showBackBtn && (
          <button type="button"
                  onClick={this.onBackPressed}
                  className={styles.headerBackBtn}>
            <Icon allowRTL={true} name="HeaderBackWhite" width="20px" height="11px" />
          </button>
        ) }
        {
          showGreeting && 
          <div style={{ alignItems: 'center', display: 'flex' }}>
            <Icon name="DefaultAvatar" width="34px" height="34px"/>
            { this.renderGreetingText() }
          </div>
        }
        {
          showLogo && <Icon name='LogoWhite' />
        }
        <div></div>
        <Icon name={humburger} 
              style={showGreeting ? {} : humburgerStyle} 
              onClick={this.onHamburgerPressed} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUserInfo: currentUserInfoSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSidebarVisibility: (visible) => dispatch(setSidebarVisibility(visible)),
  }
};

export default compose(
  withTranslation('cmp-header'),
  connect(mapStateToProps, mapDispatchToProps)
)(LayoutComponentsHeader);


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/components/header/index.jsx